import {
  InputElementUnion,
  IFileInputElement,
  mimeTypeList,
  MimeTypeToExtension,
  FileInputSchemaValidator,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "./common-properties-editor";
import { useMemo } from "react";
import { ErrorMessage } from "./helper";

type FileInputEditorProps = {
  element: IFileInputElement;
  onElementUpdate: (arg: InputElementUnion) => void;
  hideValidation?: boolean;
};

export const FileInputEditor: React.FC<FileInputEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  const schemaValidator = useMemo(() => {
    return new FileInputSchemaValidator(element);
  }, [element]);
  const acceptingExts = mimeTypeList
    .filter((s) => element.accept.includes(s))
    .map((s) => MimeTypeToExtension[s].join(", "))
    .join(", ");

  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <div className="field">
        <label
          className="label"
          htmlFor={`fileInputEditor-maxSize-${element.id}`}
        >
          最大サイズ（メガバイト）
        </label>
        <div className="field">
          <div className="control has-icons-right">
            <input
              id={`fileInputEditor-maxSize-${element.id}`}
              className="input"
              type="number"
              placeholder="チェックの値"
              value={element.maxSize}
              onChange={(e) => {
                onElementUpdate({
                  ...element,
                  maxSize: parseInt(e.target.value, 10),
                });
              }}
            />
          </div>
        </div>
        <ErrorMessage
          msg={
            schemaValidator.maxFileSizeIsNaturalNumber() ??
            schemaValidator.maxFileSize()
          }
        />
      </div>
      <div className="field">
        <label className="label">許容ファイル</label>
        <div className="field">
          <div className="control">
            <p>{acceptingExts}</p>
          </div>
        </div>
      </div>
    </>
  );
};
